var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('print-template',{attrs:{"viewFooter":false,"viewHeader":false}},[_c('svg',{attrs:{"id":'PART_ID_' + _vm.part.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }